import {
  SimilarDesignItem,
  SimilarDesigns,
} from '@app/data/clients/rbServerSideClient/queries/GetSimilarDesigns/types';
import { SIMILAR_DESIGN_PUBLIC_ENDPOINT } from '@app/pages/api/constants';
import { SimilarDesignsAPIResponse } from '@app/pages/api/similar-designs/types';
import { getSafeUrl } from '@redbubble/utils/getSafeUrl';
import { useCallback, useState } from 'react';

export interface GetSimilarDesignsParameters {
  inventoryItemId: string;
  limit?: number;
  locale: string;
  country: string;
  currency: string;
  previewTypeIds?: string[] | string | null;
  groupId?: string | null;
  isBot?: boolean;
}

const fetchSimilarDesigns = async (
  variables: GetSimilarDesignsParameters
): Promise<SimilarDesigns> => {
  const url = getSafeUrl(SIMILAR_DESIGN_PUBLIC_ENDPOINT, window.location.href);

  if (!url) {
    throw new Error('Invalid URL for similar designs endpoint');
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(variables),
  });

  const jsonData: SimilarDesignsAPIResponse = await response.json();
  if (!response.ok) {
    throw new Error(
      !Array.isArray(jsonData)
        ? jsonData.error
        : 'Failed to fetch similar designs'
    );
  }
  if (!Array.isArray(jsonData)) {
    throw new Error('Unexpected response from similar designs API');
  }
  return jsonData;
};

export const useSimilarDesigns = () => {
  const [{ similarDesigns, loading }, setSimilarDesigns] = useState<{
    similarDesigns: SimilarDesignItem[];
    loading: boolean;
  }>({
    similarDesigns: [],
    loading: true,
  });

  const refresh = useCallback((variables: GetSimilarDesignsParameters) => {
    setSimilarDesigns({ similarDesigns: [], loading: true });

    fetchSimilarDesigns(variables)
      .then((res) => {
        setSimilarDesigns({
          similarDesigns: res,
          loading: false,
        });
      })
      .catch(() => {
        // TODO: Handle errors
        setSimilarDesigns({
          similarDesigns: [],
          loading: false,
        });
      });
  }, []);

  return {
    similarDesigns,
    loading,
    refresh,
  };
};
